import { BaseService } from "./baseService";
import { PatientDto, PatientFormData } from "../types/patient";

class PatientService extends BaseService<PatientDto, PatientFormData> {
  constructor() {
    super("/Patient");
  }
}

export const patientService = new PatientService();
